<ng-container *ngIf="getCheckItemCount(check)">
	<div
		class="ms-auto clickable oo-cart-button p-button-raised"
		[style.background-color]="venue.styles?.cartButtonBackgroundColor || '#66a041'"
		[style.color]="venue.styles?.cartButtonTextColor || '#ffffff'"
		(click)="sbCart.open()"
	>
		<div class="h-100 d-flex my-auto cart-text">
			<fa-icon
				[icon]="[venue.styles?.cartButtonIconPrefix || 'far', venue.styles?.cartButtonIconName || 'shopping-cart']"
				size="lg"
				class="ms-3 my-auto"
			></fa-icon>
			<div class="d-flex mx-auto my-auto ps-2 pe-4">
				{{ getCheckItemCount(check) }}&nbsp;
				<span *ngIf="getCheckItemCount(check) === 1"> item </span>
				<span *ngIf="getCheckItemCount(check) > 1"> items </span>&nbsp;{{ check.total | currency }}
			</div>
		</div>
	</div>
</ng-container>

<div class="w-100">
	<div style="height: 100vh; width: 100vw" class="text-center p-5" *ngIf="loading">
		<h1>{{ venue?.loadingMessage }}</h1>
		<h3>Please Wait</h3>
		<h3>{{ venue?.name }}</h3>
		<ngx-loading
			[show]="true"
			[config]="{
				primaryColour: 'rgb(255,114,0,0.75)',
				secondaryColour: 'rgb(255,114,0,0.75)',
				tertiaryColour: 'rgb(255,114,0,0.75)',
				backdropBackgroundColour: 'rgb(255,255,255,0)'
			}"
		>
		</ngx-loading>
		<div class="btn btn-sm btn-secondary mt-5" (click)="openTos(tosModalTemplate)">Terms of Service</div>
	</div>

	<div style="height: 100vh; width: 100vw" class="text-center p-5" *ngIf="message">
		<h2>{{ venue?.name }}</h2>
		<h3 class="mt-3">{{ message }}</h3>
		<div class="btn btn-sm btn-secondary mt-5" (click)="displayTos = true">Terms of Service</div>
	</div>

	<div style="height: 100vh; width: 100vw" class="text-center p-5" *ngIf="error">
		<h1>{{ error }}</h1>
		<div class="btn btn-sm btn-secondary mt-5" (click)="openTos(tosModalTemplate)">Terms of Service</div>
	</div>

	<div
		#header
		class="d-flex flex-column justify-content-center"
		*ngIf="!loading && !error && !message"
		[style.background-color]="venue.styles?.headerBgColor"
	>
		<div class="d-flex" [style.background-color]="venue.styles?.headerBgColor">
			<!-- <div *ngIf="customerDto">Welcome back {{ customerDto.firstName }}</div> -->
			<div *ngIf="check && check.status === 1 && check.items.length > 0 && link && venueKey === 7166" (click)="shareCheckView = true" class="ms-auto">
				<div class="display-12">
					<span class="me-2">Share</span>
					<fa-icon [icon]="['fad', 'share-from-square']" class="m-2"></fa-icon>
				</div>
			</div>
			<div *ngIf="orderType && !query.linkKey" class="ms-auto me-1 mt-1" (click)="orderTimeTypeChange = true">
				<strong>
					<span *ngIf="orderDueDateTime">
						{{ moment(orderDueDateTime).format('l LT') }}
					</span>
					<span *ngIf="!orderDueDateTime">
						{{ orderTime }}
					</span> </strong
				>&nbsp;for&nbsp;<strong>{{ orderType.displayName }}</strong>
			</div>
		</div>
		<app-venue-header [ooVenue]="venue" [error]="error" [message]="message" [loading]="loading"></app-venue-header>

		<div class="alert alert-danger" *ngIf="alert">
			<div style="max-width: 1200px" class="d-flex h-100 align-items-center mx-auto">
				{{ alert }}
			</div>
		</div>

		<div class="d-flex flex-column justify-content-center">
			<div class="w-100 mx-auto" style="max-width: 1300px">
				<div #canvasPicker class="oo-canvas-picker d-flex flex-column" [style.background-color]="venue.styles?.menuBgColor">
					<div class="d-flex">
						<div *ngIf="isMobile" class="mx-1 mb-2 w-100">
							<mat-form-field class="w-100">
								<mat-label [style.color]="venue.styles?.headerTextColor">Select a menu...</mat-label>
								<mat-select
									[(ngModel)]="selectedCanvas"
									[style.-webkit-text-fill-color]="venue.styles?.headerTextColor"
									[(value)]="selectedCanvas"
									placeholder="Select a menu..."
								>
									<mat-option #optionValue *ngFor="let rec of ooCanvasesOnline" [value]="rec.canvasKey" (click)="selectCanvas(rec)">
										{{ rec.displayName || rec.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div *ngIf="!isMobile" class="d-flex mx-auto px-5 oo-canvases hide-scrollbar">
							<div class="oo-canvas-item" *ngFor="let canvas of ooCanvasesOnline" (click)="selectCanvas(canvas)">
								<div
									id="canvas{{ canvas.canvasKey }}"
									class="name"
									[ngClass]="{ active: selectedCanvasKey === canvas.canvasKey }"
									[style.color]="
										selectedCanvasKey === canvas.canvasKey ? venue.styles?.menuGroupSelectedColor : venue.styles?.menuGroupDeselectedColor
									"
								>
									{{ canvas.displayName || canvas.name }}
								</div>
							</div>
						</div>
						<fa-icon
							class="my-auto mx-1"
							[icon]="['far', 'search']"
							size="lg"
							(click)="enableSearch()"
							[style.color]="venue.styles?.menuGroupDeselectedColor"
						></fa-icon>
					</div>
					<div>
						<div #itemSearch *ngIf="search" class="d-flex justify-content-center" style="max-width: 1200px">
							<div class="oo-item-search d-flex flex-fill mb-2 ms-2 me-1">
								<span class="p-input-icon-left w-100">
									<i class="pi pi-search"></i>
									<input
										#searchItemValue
										type="search"
										pInputText
										placeholder="Search for your favorites..."
										class="w-100"
										[(ngModel)]="searchTerm"
									/>
								</span>
							</div>
							<div class="oo-item-tag-list d-flex mb-2 ms-1 me-2" *ngIf="menuItemTagList.length > 0">
								<span class="p-float-label">
									<p-multiSelect
										#menuItemTagListSelect
										[(ngModel)]="searchTags"
										[options]="menuItemTagList"
										optionLabel="name"
										optionValue="key"
										name="menuItemTagList"
										(onChange)="searchForItemByTag($event.value)"
										[style]="{ width: '100%' }"
										appendTo="body"
										autoDisplayFirst="false"
										placeholder="Search by tag..."
									>
										<ng-template let-item pTemplate="item">
											<p-tag [value]="item.name" [severity]="item.severity"></p-tag>
										</ng-template>
									</p-multiSelect>
								</span>
							</div>
						</div>
					</div>
				</div>

				<!-- <ng-scrollbar class="flex-grow-1" [style.background-color]="venue.styles?.siteBgColor"> -->
				<div [style.background-color]="venue.styles?.menuBgColor">
					<ng-container *ngIf="searchItemResults?.length > 0" class="flex-grow-1" [style.background-color]="venue.styles?.menuBgColor">
						<p-dataView
							id="searchResultsDataView"
							[value]="searchItemResults | ItemOutOfStockPipe : venue | ItemUnavailablePipe : venue"
							[layout]="isMobile ? 'list' : 'p-grid'"
							filterBy="name,displayName,description"
						>
							<ng-template pTemplate="header">
								<div class="d-flex justify-content-between">
									<div class="h3">Search results...</div>
									<fa-icon [icon]="['far', 'times-circle']" size="2x" (click)="searchItemResults = []"></fa-icon>
								</div>
							</ng-template>
							<ng-template let-item let-itemIndex pTemplate="listItem">
								<div class="p-col-12 border border-white" [style.background-color]="venue.styles?.menuBgColor">
									<ng-template
										*ngTemplateOutlet="
											canvasMenuItemSelection;
											context: { $implicit: item, canvasIndex: undefined, menuItemIndex: itemIndex }
										"
									>
									</ng-template>
								</div>
							</ng-template>
							<ng-template let-item pTemplate="p-gridItem">
								<div class="p-col-12 p-md-4 border border-white" [style.background-color]="venue.styles?.menuBgColor">
									<ng-template *ngTemplateOutlet="canvasMenuItemSelection; context: { $implicit: item }"> </ng-template>
								</div>
							</ng-template>
							<ng-template pTemplate="empty"> </ng-template>
						</p-dataView>
					</ng-container>
					<div class="d-flex flex-column mx-auto">
						<ng-container *ngFor="let canvas of ooCanvasesOnline | CanvasUnavailablePipe : venue; let canvasIndex = index" class="d-flex">
							<div class="oo-menu-items mx-1">
								<p-dataView
									(nguiInview)="selectCanvasEvaluate(canvas.canvasKey)"
									[id]="+canvas.canvasKey"
									[value]="canvas.menuItems | ItemOutOfStockPipe : venue | ItemUnavailablePipe : venue"
									[style.background-color]="venue.styles?.menuBgColor"
									[layout]="'list'"
									filterBy="name,displayName,description"
								>
									<ng-template pTemplate="header">
										<div class="canvas">
											<div [style.background-color]="venue.styles?.menuBgColor">
												<p-divider align="left" [style.background]="venue.styles?.menuBgColor">
													<div
														class="display-8"
														[style.color]="venue.styles?.menuItemNameColor"
														[style.background-color]="venue.styles?.menuBgColor"
													>
														{{ canvas.displayName || canvas.name }}
													</div>
												</p-divider>
											</div>

											<div [style.background]="venue.styles?.menuBgColor" class="p-grid mx-1">
												<div class="p-col-12 p-md-6">
													<div class="d-flex flex-column w-100" [ngClass]="isMobile ? '' : 'ms-5'">
														<div
															*ngIf="canvas.description"
															class="d-flex m-2 display-14 canvas-description"
															[ngClass]="isMobile ? 'text-center' : 'text-left'"
															[style.color]="venue.styles?.menuItemDescriptionColor"
														>
															{{ canvas.description }}
														</div>
													</div>
												</div>
												<div class="p-col-12 p-md-6">
													<img
														*ngIf="canvas.imageKey"
														alt="{{ canvas.displayName }}"
														class="mx-auto my-auto canvas-image"
														width="100%"
														height="auto"
														[src]="
															'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
															(venue.linkedVenueKey || venueKey) +
															'/' +
															canvas.imageKey +
															'?' +
															timestamp
														"
													/>
												</div>
											</div>
											<div [style.background]="venue.styles?.menuBgColor" class="h-100">
												<div [id]="'canvas-' + canvas.canvasKey"></div>

												<div *ngIf="!canvas.available" class="d-flex text-center p-text-bold text-lowercase m-2" style="color: red">
													{{ canvas.unavailableMessage }}
												</div>
											</div>
										</div>
									</ng-template>
									<ng-template let-item let-itemIndex pTemplate="listItem">
										<div class="p-col-12 p-md-6 p-lg-4 p-xl-3 menu-item">
											<div
												class="item-cell"
												[style.background-color]="venue.styles?.canvasItemCellBgColor"
												[style.border-color]="venue.styles?.canvasItemCellBgColor"
											>
												<ng-template *ngTemplateOutlet="canvasMenuItemSelection; context: { $implicit: item }"> </ng-template>
											</div>
										</div>
									</ng-template>
								</p-dataView>
							</div>
						</ng-container>
					</div>
				</div>

				<div class="d-flex w-100 justify-content-center p-3 border-top mt-3">
					<div class="btn btn-sm btn-secondary" (click)="displayTos = true">Terms of Service</div>
				</div>
				<!-- </ng-scrollbar> -->
			</div>
		</div>
	</div>
</div>

<ng-template #canvasMenuItemSelection let-item>
	<div class="animation-fade-in animation-duration-240s h-100 menu-item" (click)="openMenuItemModal(item, menuItemModalTemplate)">
		<div class="d-flex flex-column h-100 w-100">
			<div class="p-grid w-100">
				<div>
					<div class="d-flex flex-column w-100">
						<div class="header-name-price m-2">
							<div class="name">
								{{ item.displayName || item.name }}
							</div>
							<div class="price">
								{{ getMenuItemPrice(item) | currency }}
							</div>
						</div>
						<div *ngIf="venue.styles.canvasShowItemDescription" [ngClass]="query.mode === 'menu' ? 'description-view-only' : 'description'">
							{{ item.description }}
						</div>
					</div>
				</div>
			</div>
			<div class="p-grid my-auto">
				<div *ngIf="!item.hideImages" class="my-auto w-100">
					<div class="w-100 d-flex">
						<img
							*ngIf="item.imageUrl"
							class="image"
							[ngClass]="!venue.styles.menuItemBoxShadow && 'no-shadow'"
							[src]="item.imageUrl"
							onError="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + (venue.linkedVenueKey || venueKey) +
						'/default.png'"
							[alt]="item.displayName || item.name"
						/>
						<img
							*ngIf="!item.imageUrl"
							class="image"
							[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + (venue.linkedVenueKey || venueKey) + '/default.png'"
							onError="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/default.png"
							[alt]="item.displayName || item.name"
						/>
					</div>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col-12">
					<div class="tags">
						<p-tag *ngIf="item.outOfStock && venue.displayOutOfStockItemStatus" value="Out of Stock" severity="danger" styleClass="tag"></p-tag>
						<p-tag
							*ngIf="item.countdown && venue.displayCountdownItemStatus"
							[value]="venue.limitedAvailabilityTag || 'Limited availability'"
							severity="warning"
							styleClass="tag"
						></p-tag>
						<p-tag *ngIf="!item.available" [value]="item.unavailableMessage" severity="danger" styleClass="tag"></p-tag>
						<ng-container *ngFor="let tag of item.OOMenuItemTags">
							<p-tag *ngIf="tag?.OOTags && tag?.OOTags.name" [value]="tag.OOTags.name" [severity]="tag.OOTags.severity" styleClass="tag"> </p-tag>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #menuItemModalTemplate let-modal>
	<div class="oo-menu-item-modal" [style.background-color]="venue.styles?.menuItemDetailBgColor">
		<div #body class="body">
			<div class="p-3" style="position: absolute; top: 0; right: 0; z-index: 1">
				<div class="btn btn-light" (click)="modalRef.close()">
					<fa-icon [icon]="['fas', 'times']" size="2x"></fa-icon>
				</div>
			</div>
			<ng-scrollbar class="flex-grow-1">
				<div class="image" *ngIf="menuItemSelected.imageUrl">
					<img
						class="w-100"
						[src]="menuItemSelected.imageUrl"
						(error)="$event.target.src = 'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/default.png?' + timestamp"
					/>
				</div>
				<div class="px-4 d-flex flex-column">
					<div class="name" [style.color]="venue.styles?.menuItemDetailNameColor">
						{{ menuItemSelected.displayName || menuItemSelected.name }}
					</div>
					<div class="price">
						{{ getMenuItemPrice(menuItemSelected) | currency }}
					</div>
					<div *ngIf="!menuItemSelected.available" class="item-unavailable">
						{{ menuItemSelected.unavailableMessage }}
					</div>
					<div class="description" [style.color]="venue.styles?.menuItemDetailDescriptionColor">
						{{ menuItemSelected.description }}
					</div>
					<div class="d-flex" *ngIf="menuItemSelected.OOMenuItemTags">
						<div *ngFor="let tag of menuItemSelected.OOMenuItemTags">
							<p-tag [value]="tag.OOTags.name" styleClass="m-2" [severity]="tag.OOTags.severity"></p-tag>
						</div>
					</div>
					<div #modOptionAnchor class="d-flex ms-1"></div>
					<div #modifiers class="modifiers" *ngIf="showModal">
						<div *ngIf="showPriceLevels" class="oo-mod-canvas">
							<p-radioButton
								*ngFor="let priceLevel of priceLevels"
								name="priceNumber"
								[label]="priceLevel.label"
								[value]="priceLevel.value"
								[(ngModel)]="menuItemSelected.priceNumber"
								(ngModelChange)="selectPriceNumber(menuItemSelected.priceNumber, menuItemSelected)"
							>
							</p-radioButton>
						</div>
						<ng-container *ngIf="showModifiers">
							<ng-container *ngFor="let canvas of menuItemSelected.canvases; let canvasIdx = index" class="oo-mod-canvas">
								<ng-container *ngIf="canvas.online && canvas.options?.length > 0">
									<p-card #ooModifierCard{{canvasIdx}} styleClass="m-2">
										<ng-template pTemplate="header">
											<div class="d-flex">
												<div class="oo-mod-canvas ms-2" [style.color]="venue.styles?.menuItemDetailModGroupColor">
													<div class="oo-mod-canvas-name">
														{{ canvas.displayName || canvas.name }}
													</div>
												</div>
												<div class="ms-auto">
													<div class="oo-mod-canvas-name" [style.color]="venue.styles?.menuItemDetailModGroupColor">
														<span class="small text-danger" *ngIf="canvas.min === 1">Required</span>
														<span class="mx-1 small text-danger" *ngIf="canvas.min > 1">{{ +canvas.min }} required</span>
														<span class="mx-1 small text-danger" *ngIf="canvas.min > 1 || canvas.max > 1">
															select up to {{ canvas.max }}</span
														>
													</div>
												</div>
											</div>
										</ng-template>
										<div #ooModifier{{canvasIdx}} class="oo-mod-canvas">
											<div *ngFor="let option of canvas.options; let menuItemIdx = index">
												<div class="d-flex">
													<div class="me-2">
														<p-checkbox
															[name]="'mod' + canvas.canvasKey"
															[(ngModel)]="menuItemModifiers[canvasIdx][menuItemIdx]"
															(ngModelChange)="selectModifier(canvasIdx, menuItemIdx, canvas, option.value, $event)"
															[value]="option.value"
															[disabled]="option.value.menuItem.outOfStock"
															labelStyleClass="mt-2"
															styleClass="ms-4"
														></p-checkbox>
													</div>

													<div class="me-2 mb-2">
														<span [style.color]="venue.styles?.menuItemDetailModNameColor">{{ option.label }}</span>
														<p-tag
															value="Out of Stock"
															styleClass="me-2 ms-2 mb-4"
															severity="danger"
															*ngIf="option.value.menuItem.outOfStock"
														>
														</p-tag>
														<div
															*ngIf="option.value.menuItem.description"
															class="oo-mod-description"
															[style.color]="venue.styles?.menuItemDetailModDescriptionColor"
														>
															{{ option.value.menuItem.description }}
														</div>
													</div>
												</div>
												<ng-container
													*ngIf="option.value.menuItem.canvases && menuItemModifiers[canvasIdx][menuItemIdx].includes(option.value)"
												>
													<div *ngFor="let canvas2 of option.value.menuItem.canvases; let modCanvasIdx = index" class="ms-4">
														<ng-container *ngIf="canvas2.options?.length > 0 && canvas2.online">
															<div class="oo-mod-canvas-name" [style.color]="venue.styles?.menuItemDetailModGroupColor">
																{{ canvas2.displayName || canvas2.name }}
																<span class="ms-2 small text-danger" *ngIf="canvas2.min > 0">{{ canvas2.min }} Required</span>
																<span class="ms-2 small text-danger" *ngIf="canvas2.max > 0">{{ canvas2.max }} Allowed</span>
															</div>
															<div *ngFor="let option2 of canvas2.options; let modMenuItemIdx = index">
																<p-checkbox
																	[name]="'mod' + canvas2.canvasKey"
																	[(ngModel)]="menuItemSubModifiers[canvasIdx][menuItemIdx][modCanvasIdx]"
																	(ngModelChange)="
																		selectSubModifier(canvasIdx, menuItemIdx, modCanvasIdx, canvas2, option2.value, $event)
																	"
																	[label]="option2.label"
																	[value]="option2.value"
																	labelStyleClass="mt-2"
																	styleClass="ms-4"
																	[style.color]="venue.styles?.menuItemDetailModNameColor"
																>
																</p-checkbox>
																<div
																	*ngIf="option2.value.menuItem.description"
																	class="oo-mod-description"
																	[style.color]="venue.styles?.menuItemDetailModDescriptionColor"
																>
																	{{ option2.value.menuItem.description }}
																</div>
															</div>
														</ng-container>
													</div>
												</ng-container>
											</div>
										</div>
									</p-card>
								</ng-container>
							</ng-container>
						</ng-container>
						<div class="oo-mod-canvas p-fluid">
							<div
								class="oo-mod-canvas-name mb-2"
								*ngIf="venue.displaySpecialInstructions"
								[style.color]="venue.styles?.menuItemDetailModGroupColor"
							>
								<div>Special Instructions<span class="text-muted"> (optional)</span></div>
								<input pInputText name="menuItemComment1" [(ngModel)]="menuItemComment1" maxlength="23" />
							</div>
							<div class="oo-mod-canvas-name mb-2" *ngIf="venue.displayWhoThisFor" [style.color]="venue.styles?.menuItemDetailModGroupColor">
								<div>Who is this for?<span class="text-muted"> (optional)</span></div>
								<input pInputText name="menuItemComment2" [(ngModel)]="menuItemComment2" maxlength="19" />
							</div>
						</div>
					</div>
				</div>
			</ng-scrollbar>
		</div>
		<div class="footer">
			<div *ngIf="showModal" class="d-flex flex-column p-fluid">
				<div class="d-flex align-items-center justify-content-center">
					<div class="mx-1" style="flex: 0 0 75px">
						<p-inputNumber
							name="menuItemQty"
							[(ngModel)]="menuItemQty"
							[disabled]="menuItemSelected.outOfStock || !menuItemSelected.available || !allowOrder"
							(ngModelChange)="updateMenuItemTotal()"
							min="1"
							[showButtons]="true"
						></p-inputNumber>
					</div>
					<button *ngIf="!allowOrder" type="button" class="btn btn-warning ms-1 flex-grow-1">Sorry, we're currently not accepting orders</button>

					<button *ngIf="menuItemSelected.outOfStock" type="button" class="btn btn-danger ms-1 flex-grow-1">
						Sorry, this item is currently out of stock.
					</button>
					<button *ngIf="!menuItemSelected.available" type="button" class="btn btn-danger ms-1 flex-grow-1">
						Sorry, this item is currently unavailable.
					</button>

					<button
						*ngIf="!(checkItemIdx >= 0) && allowOrder && !menuItemSelected.outOfStock && menuItemSelected.available"
						type="button"
						class="btn btn-primary ms-1 flex-grow-1"
						[disabled]="!menuItemSelected.valid || !allowOrder || !menuItemSelected.available"
						(click)="addMenuItem(menuItemSelected, menuItemQty)"
					>
						Add To Order {{ menuItemTotal | currency }}
					</button>

					<button
						*ngIf="checkItemIdx >= 0"
						type="button"
						class="btn btn-primary ms-1 flex-grow-1"
						[disabled]="!menuItemSelected.valid || !allowOrder || !menuItemSelected.available"
						(click)="addMenuItem(menuItemSelected, menuItemQty, checkItemIdx)"
					>
						Update Order {{ menuItemTotal | currency }}
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<focus-sidebar
	#sbCart
	header="My Order"
	[showCloseIcon]="true"
	size="xxs"
	[footerTemplate]="sbCartFooterTemplate"
	[dismissible]="true"
	(onClose)="alternateReset()"
	(onOpen)="initSidebar()"
	[bodyColor]="venue?.styles?.checkBgColor"
	[headerColor]="venue?.styles?.checkBgColor"
	[footerColor]="venue?.styles?.checkBgColor"
>
	<form #f="ngForm" class="flex-grow-1">
		<div class="p-3 d-flex flex-column">
			<ngx-loading
				[show]="saving"
				[config]="{
					primaryColour: 'rgb(255,114,0,0.75)',
					secondaryColour: 'rgb(255,114,0,0.75)',
					tertiaryColour: 'rgb(255,114,0,0.75)',
					backdropBackgroundColour: 'rgb(255,255,255,.5)'
				}"
			>
			</ngx-loading>

			<p-messages key="sidebar"></p-messages>

			<h3 class="mb-3 mx-auto" *ngIf="orderStatusMessage">{{ orderStatusMessage }}</h3>

			<!-- CHECK -->
			<ng-container *ngIf="check && venue && checkoutStep === 'check'">
				<div class="oo-check-item" *ngFor="let item of check.items; let idx = index">
					<div class="d-flex mb-1 align-items-center">
						<div class="qty" style="flex: 0 0 75px">
							<p-inputNumber
								[name]="'qty' + idx"
								[(ngModel)]="item.qty"
								(ngModelChange)="updateCheckTotals(check)"
								min="1"
								required
								[showButtons]="true"
								*ngIf="!item.locked && !item.deliveryFee"
							></p-inputNumber>
							<span *ngIf="item.locked">{{ item.qty }}</span>
						</div>
						<div class="name" [style.color]="venue.styles?.checkItemNameColor" [ngClass]="{ 'text-danger': item.outOfStock }">
							<fa-icon *ngIf="item.outOfStock" icon="exclamation-triangle" class="me-1"></fa-icon>
							{{ item.displayName || item.name }}
						</div>
						<div class="price">
							{{ getCheckItemTotal(item) | currency }}
						</div>
					</div>
					<div class="modifiers">
						<div class="d-flex" *ngIf="item.priceNumberName">
							<div class="qty"></div>
							<div class="d-flex">
								<div class="d-flex flex-column me-3">
									<div class="modifier">
										<div class="mod-name" [style.color]="venue.styles?.checkModNameColor">
											<fa-icon *ngIf="item.outOfStock" icon="exclamation-triangle" class="me-1"> </fa-icon
											>{{ getPriceNumberName(item.key, item.priceNumber) }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex" *ngIf="item.modifiers.length > 0">
							<div class="qty"></div>
							<div class="d-flex">
								<div class="d-flex flex-column me-3">
									<div class="modifier" *ngFor="let modifier of item.modifiers; let idx2 = index">
										<div
											class="mod-name"
											[style.color]="venue.styles?.checkModNameColor"
											[ngClass]="{ 'text-danger': modifier.outOfStock, 'ms-3': modifier.level === 2 }"
										>
											{{ modifier?.displayName || modifier?.name }}
										</div>
									</div>
								</div>
								<div class="d-flex flex-column">
									<div class="modifier" *ngFor="let modifier of item.modifiers; let idx2 = index">
										<div *ngIf="!modifier.kitchenComment && modifier.price > 0">
											<span class="text-muted small">{{ modifier.price | currency }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex">
						<div class="qty"></div>
						<div
							class="ms-auto btn btn-secondary btn-sm mt-2 me-1"
							*ngIf="!item.locked && !item.deliveryFee && !item.quickAdd"
							(click)="sbCart.close(); openMenuItemModal(item, menuItemModalTemplate, idx)"
						>
							Edit
						</div>
						<div
							class="btn btn-danger btn-sm mt-2"
							*ngIf="!item.locked && !item.deliveryFee"
							(click)="removeItemFromCheck(idx); updateCheckTotals(check); initSidebar()"
						>
							Remove
						</div>
					</div>
				</div>
			</ng-container>

			<!-- HOW / WHEN -->
			<ng-container *ngIf="checkoutStep === 'orderHow'">
				<div class="d-flex flex-column w-100">
					<ng-container>
						<div class="p-fluid mb-3 text-center" *ngIf="orderTypeOptions && !query.orderType && this.check.orderType">
							<h3 class="mb-3 mx-auto">How do you want It?</h3>
							<p-selectButton
								[options]="orderTypeOptions"
								optionDisabled="disabled"
								[(ngModel)]="check.orderType"
								(ngModelChange)="selectOrderType(check.orderType)"
								name="orderType"
								[style]="{ 'flex-direction': 'column' }"
							>
							</p-selectButton>
						</div>
						<div class="m-2 text-danger" *ngIf="!deliveryAllowed && check.shipping.address1">
							{{
								orderType.outOfDeliveryZoneMessage ||
									"Sorry, we're not currently delivering to your
                        address"
							}}
						</div>
						<div class="m-2 text-danger">
							{{ orderType.orderTypeNote }}
						</div>
						<div class="m-2" *ngIf="!deliveryAllowed && !check.shipping.address1">Please provide your delivery address</div>
						<div class="m-2" *ngIf="deliveryAllowed && check.shipping.address1"></div>
						<div class="m-2" *ngIf="orderType.promptAddress">
							<address-selection-input
								[autocompleteInput]="addressAutoCompleteValue"
								(selectAddress)="handleAddressSelect($event)"
								source="checkoutForm"
								addressType="geocode"
							></address-selection-input>
							<div class="mt-4">
								<span class="p-float-label">
									<input pInputText type="text" id="street2" name="name" [(ngModel)]="check.shipping.address2" class="w-100" />
									<label for="street2">Suite/Apartment #</label>
								</span>
							</div>
						</div>

						<div class="p-fluid mb-3 text-center" *ngIf="orderType.futureOrders && futureOrderOptions.length > 0">
							<h3 class="mb-3 mx-auto">When do you want it?</h3>
							<p-selectButton
								[options]="futureOrderOptions"
								[(ngModel)]="check.futureOrder"
								name="futureOrder"
								[style]="{ 'flex-direction': 'column' }"
							>
								<ng-template let-item>
									<div class="d-flex flex-column align-items-center w-100">
										<div>
											{{ item.label }}
										</div>
										<div *ngIf="item.value === 'now'">
											{{ dueDateTimeMessage }}
										</div>
									</div>
								</ng-template>
							</p-selectButton>
						</div>
						<div class="p-fluid" *ngIf="orderType?.futureOrders && check.futureOrder === 'later'">
							<p-calendar
								[(ngModel)]="futureOrderDate"
								name="futureOrderDate"
								[minDate]="futureOrderMinDate"
								inputStyleClass="text-center"
								(onSelect)="selectFutureOrderDate(futureOrderDate)"
								required
								[minDate]="futureOrderMinDate"
								[maxDate]="futureOrderMaxDate"
								readonlyInput="true"
							>
							</p-calendar>
						</div>
						<div class="p-fluid mt-3 mb-3 text-center" *ngIf="orderType?.futureOrders && check.futureOrder === 'later'">
							<p-dropdown
								name="futureOrderTime"
								[(ngModel)]="futureOrderTime"
								[options]="futureOrderTimeOptions"
								[autoDisplayFirst]="false"
								placeholder="Select Time"
								required
							></p-dropdown>
						</div>
						<ng-container *ngIf="orderType">
							<div class="p-fluid mb-3 text-center" *ngFor="let field of orderType.ooOrderTypeFields">
								<h3 class="mb-3 mx-auto">{{ field.key }}</h3>
								<input type="text" [required]="field.required" pInputText [(ngModel)]="check.meta[field.key]" [name]="field.key" />
							</div>
						</ng-container>
					</ng-container>
				</div>
			</ng-container>

			<!-- ORDER DETAILS -->
			<ng-container *ngIf="checkoutStep === 'orderDetails'">
				<div class="p-fluid mb-3 text-center" *ngIf="orderType?.tipped">
					<h3 class="mb-3 mx-auto">Add a Tip?</h3>
					<p-dropdown
						name="tipSelected"
						[(ngModel)]="tipSelected"
						placeholder="Select tip amount"
						[options]="tipOptions"
						(onChange)="selectTip(tipSelected)"
						required
					></p-dropdown>
					<div class="p-inputgroup mt-3" *ngIf="tipSelected === 4">
						<span class="p-inputgroup-addon">$</span>
						<input type="number" min="0" pInputText [(ngModel)]="tipCustom" name="tipCustom" (ngModelChange)="selectTip(4)" />
					</div>
				</div>

				<div class="p-fluid mb-3 text-center">
					<h3 class="mb-3 mt-3 ms-auto me-auto">Order Details</h3>
					<div class="d-flex">
						<span class="p-float-label mb-4 flex-grow-1 me-1">
							<input
								type="text"
								autocomplete="cc-given-name"
								required
								pInputText
								name="billing_firstName"
								[(ngModel)]="check.billing.firstName"
								NoWhitespaceValidator
							/>
							<label>First Name</label>
						</span>
						<span class="p-float-label mb-4 flex-grow-1 ms-1">
							<input
								type="text"
								autocomplete="cc-family-name"
								required
								pInputText
								name="billing_lastName"
								[(ngModel)]="check.billing.lastName"
								NoWhitespaceValidator
							/>
							<label>Last Name</label>
						</span>
					</div>
					<div class="d-flex">
						<span class="p-float-label mb-4 flex-grow-1 me-1">
							<input
								type="tel"
								autocomplete="tel"
								required
								pInputText
								name="billing_phone"
								[(ngModel)]="check.billing.phone"
								phone="US"
								mask="(000) 000-0000"
							/>
							<label>Phone Number</label>
						</span>
						<span class="p-float-label mb-4 flex-grow-1 ms-1">
							<input
								type="email"
								autocomplete="email"
								[required]="orderType.requireEmail && !orderType?.atTable"
								pInputText
								name="billing_email"
								[(ngModel)]="check.billing.email"
								email
							/>
							<label>Email</label>
						</span>
					</div>

					<ng-container *ngIf="false">
						<!-- <h3 class="mb-3 mt-3 ms-auto me-auto">Delivery Details</h3> -->
						<span class="p-float-label mb-4">
							<input
								type="text"
								autocomplete="address-line1"
								required
								pInputText
								name="delivery_address1"
								[(ngModel)]="check.shipping.address1"
							/>
							<label>Delivery Address</label>
						</span>
						<span class="p-float-label mb-4">
							<input type="text" autocomplete="address-line2" pInputText name="delivery_address2" [(ngModel)]="check.shipping.address2" />
							<label>Apt, Suite, Etc (optional)</label>
						</span>
						<div class="d-flex">
							<span class="p-float-label mb-4 flex-grow-1 me-1">
								<input type="text" autocomplete="address-level2" required pInputText name="delivery_city" [(ngModel)]="check.shipping.city" />
								<label>City</label>
							</span>
							<span class="p-float-label mb-4 flex-grow-1 ms-1">
								<p-dropdown
									autocomplete="address-level1"
									required
									name="delivery_state"
									[(ngModel)]="check.shipping.state"
									[options]="app.references.states"
									[autoDisplayFirst]="false"
								>
								</p-dropdown>
								<label>State</label>
							</span>
						</div>
						<span class="p-float-label mb-4">
							<input
								type="text"
								autocomplete="postal-code"
								required
								pInputText
								name="delivery_postalCode"
								[(ngModel)]="check.shipping.postalCode"
							/>
							<label>Postal Code</label>
						</span>
					</ng-container>
				</div>
			</ng-container>

			<!-- PAYMENT METHOD -->
			<ng-container *ngIf="checkoutStep === 'paymentMethod' || checkoutStep === 'orderReview'">
				<h3 class="mb-3 mx-auto">Payment Method</h3>
				<div class="d-flex flex-column align-content-between">
					<div #paymentMethods class="payment-methods">
						<div class="d-flex flex-column w-100 container-fluid text-center">
							<div *ngIf="(!venue.ooOrderTypes || venue.ooOrderTypes.length === 0 || orderType?.payCreditCard) && check.total > 0">
								<ng-container *ngIf="!kioskMode">
									<div *ngIf="venue.ccProcessor === 1">
										<div class="mb-4">
											<app-stored-credit-card
												*ngIf="onlineCustomer && onlineCustomer.creditCards"
												[customerCreditCards]="onlineCustomer.creditCards"
												(paymentTypeSelectedChange)="storedCreditCardResponse($event)"
											></app-stored-credit-card>
										</div>

										<app-i4go-payment
											*ngIf="i4goCardOther && paymentUseNewCard"
											[billingCity]="check.billing.city"
											[billingState]="check.billing.state"
											[billingStreet]="check.billing.address1"
											[billingZip]="check.billing.postalCode"
											[email]="check.billing.email"
											[firstName]="check.billing.firstName"
											[lastName]="check.billing.lastName"
											[orderId]="check.checkKey"
											[shippingCity]="check.shipping?.city"
											[shippingState]="check.shipping?.state"
											[shippingStreet]="check.shipping?.address1"
											[shippingZip]="check.shipping?.postalCode"
											[transactionAmount]="check.total"
											[venueKey]="venue.venueKey"
											[checkItems]="check.items"
											[phone]="check.billing.phone"
											(i4goResponse)="i4goPaymentToOrderPayment($event)"
										>
										</app-i4go-payment>
									</div>

									<app-auth-net-payment
										*ngIf="venue.ccProcessor === 2"
										[billingZip]="check.billing.postalCode"
										[firstName]="check.billing.firstName"
										[lastName]="check.billing.lastName"
										[transactionAmount]="check.total"
										[venueKey]="venue.venueKey"
										(i4goResponse)="i4goPaymentToOrderPayment($event)"
									>
									</app-auth-net-payment>

									<app-focuspay-payment
										*ngIf="venue.ccProcessor === 4"
										[transactionAmount]="check.total"
										(processorResponseChange)="i4goPaymentToOrderPayment($event)"
									></app-focuspay-payment>

									<app-datacap-payment
										*ngIf="venue.ccProcessor === 5 && !kioskMode"
										[datacapApiSecret]="venue.ccProcessorApiSecret"
										[transactionAmount]="check.total"
										(i4goPaymentResponseDTOChange)="i4goPaymentToOrderPayment($event)"
									></app-datacap-payment>
								</ng-container>
								<ng-container *ngIf="kioskMode">
									<app-kiosk-payment
										[checkKey]="order.checkKey"
										[orderTotal]="check.total"
										[orderTip]="check.tip"
										[orderTax]="check.tax"
										[venueKey]="venueKey"
										(paymentResponse)="i4goPaymentToOrderPayment($event)"
									></app-kiosk-payment>
								</ng-container>
							</div>

							<button
								*ngIf="orderType?.payGift && venue.giftProcessor"
								label="Gift Card"
								pButton
								pRipple
								class="p-button-raised my-2 w-100"
								(click)="paymentMode = 'gift'; i4goCardOther = false"
							>
								<fa-icon class="me-2 ms-2" [icon]="['far', 'gift-card']"></fa-icon>
							</button>

							<div class="d-flex flex-column w-100 container-fluid" *ngIf="paymentMode === 'gift'">
								<app-gift-card-payment
									[check]="check"
									[total]="check.total"
									[tip]="check.tip"
									[venueKey]="venue.venueKey"
									(giftProcessed)="applyGiftCard($event)"
								>
								</app-gift-card-payment>
								<div *ngIf="giftAccount && giftAmount > 0">
									<h4>
										<fa-icon [icon]="['far', 'check']"></fa-icon>
										Gift card {{ giftAccount }} applied for {{ giftAmount | currency : 'USD' }}
									</h4>
								</div>
							</div>

							<button
								*ngIf="orderType?.payAtStore && !giftAmount"
								label="Pay at the Store"
								pButton
								pRipple
								class="p-button-raised p-button-warning my-2 w-100"
								(click)="paymentMode = 'store'; nextStep()"
							>
								<fa-icon class="me-2 ms-2" [icon]="['far', 'store']"></fa-icon>
							</button>
						</div>
					</div>
					<div #orderSummary class="order-summary">
						<div class="border check-result mb-3 p-3">
							<div class="row" *ngIf="check.billing.firstName">
								<div class="col-4 col-label">Name</div>
								<div class="col">{{ check.billing.firstName }} {{ check.billing.lastName }}</div>
							</div>
							<div class="row" *ngIf="check.billing.phone">
								<div class="col-4 col-label">Phone</div>
								<div class="col">
									{{ check.billing.phone }}
								</div>
							</div>
							<div class="row" *ngIf="check.billing.email">
								<div class="col-4 col-label">Email</div>
								<div class="col">
									{{ check.billing.email }}
								</div>
							</div>
							<div class="row" *ngIf="orderType">
								<div class="col-4 col-label">Order Type</div>
								<div class="col">
									{{ orderType.displayName }}
								</div>
							</div>
							<div class="row" *ngIf="!orderType.atTable">
								<div class="col-4 col-label">Order Ready</div>
								<div class="col">
									<span>{{ order.dueDateTime | amLocal | amDateFormat : 'LLL' }}</span>
								</div>
							</div>
							<div class="row" *ngIf="orderType">
								<div class="col-4 col-label"></div>
								<div class="col">
									{{ orderType.instructions }}
								</div>
							</div>
							<div class="row" *ngIf="check.creditCard.displayName">
								<div class="col-4 col-label">Payment Method</div>
								<div class="col">
									{{ check.creditCard.displayName }}
								</div>
							</div>
							<div class="row">
								<div class="col-4 col-label">Total</div>
								<div class="col">
									{{ check.total | currency }}
								</div>
							</div>
						</div>

						<div *ngIf="orderType?.promptAddress" class="border check-result mb-3 p-3">
							<div class="row">
								<div class="col-4 col-label">Delivery Address</div>
								<div class="col">
									<div *ngIf="check.shipping.address1">{{ check.shipping.address1 }}</div>
									<div *ngIf="check.shipping.address2">{{ check.shipping.address2 }}</div>
									<div *ngIf="check.shipping.city">
										{{ check.shipping.city }}, {{ check.shipping.state }}
										{{ check.shipping.postalCode }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="checkoutStep === 'orderSubmitting'">
				<app-order-status [ooStyles]="venue.styles" [isFutureOrder]="check.futureOrder !== 'now'"> </app-order-status>
			</ng-container>

			<!-- ORDER COMPLETE -->
			<ng-container *ngIf="checkoutStep === 'orderComplete'">
				<div class="border check-result mb-3 p-3">
					<div class="row">
						<div class="col-4 col-label">Total</div>
						<div class="col">
							{{ check.total | currency }}
						</div>
					</div>
					<div class="row" *ngIf="!order.futureOrder && check.status === 1">
						<div class="col-4 col-label">Check #</div>
						<div class="col">
							{{ check?.checkNumber }}
						</div>
					</div>
					<div class="row" *ngIf="orderType">
						<div class="col-4 col-label">Order Type</div>
						<div class="col">
							{{ orderType.displayName }}
						</div>
					</div>
					<div class="row" *ngIf="check.status === 1">
						<div class="col-4 col-label">Order Ready</div>
						<div class="col">
							<span>{{ order.dueDateTime | amLocal | amDateFormat : 'LLL' }}</span>
						</div>
					</div>
					<div class="row" *ngIf="orderType && check.status === 1">
						<div class="col-4 col-label"></div>
						<div class="col">
							{{ orderType.instructions }}
						</div>
					</div>
				</div>

				<div class="p-3 text-center" *ngIf="!order.futureOrder && check.status === 1 && (check.billing?.email || customer?.email)">
					A receipt has been emailed to {{ check.billing.email || customer.email }}
				</div>

				<div class="p-3 text-center" *ngIf="!order.futureOrder && check.status === 1">
					<div *ngIf="orderType.checkoutReceiptStyle === 1" class="">
						<a href="{{ receiptUrl }}" target="_blank" class="btn btn-primary w-100 mt-2">View Receipt</a>
					</div>
					<div *ngIf="orderType.checkoutReceiptStyle === 2" class="">
						<qrcode [qrdata]="receiptUrl" width="256" errorCorrectionLevel="'M'"></qrcode>
					</div>
				</div>

				<div *ngIf="venue.loyaltyApiKey && !check.loyaltyAccount && paymentMode !== 'store'" class="border p-3 mt-3">
					<app-loyalty-account-lookup-post [check]="check" [venueKey]="venue.venueKey" [postImmediately]="false"> </app-loyalty-account-lookup-post>
				</div>
			</ng-container>

			<!-- PAYMENT COMPLETE -->
			<ng-container *ngIf="checkoutStep === 'paymentComplete'">
				<div class="border check-result mb-3 p-3">
					<div class="row">
						<div class="col-4 col-label">Total</div>
						<div class="col">
							{{ paymentResult.amount | currency }}
						</div>
					</div>
					<div class="row" *ngIf="paymentResult.tip">
						<div class="col-4 col-label">Tip</div>
						<div class="col">
							{{ paymentResult.tip | currency }}
						</div>
					</div>
				</div>

				<div class="p-3 text-center">A receipt has been emailed to {{ paymentResult.email }}</div>

				<div class="p-3 text-center">
					<a href="{{ receiptUrl }}" target="_blank" class="btn btn-primary w-100">View Receipt</a>
				</div>
			</ng-container>

			<ng-container *ngIf="checkoutStep === 'orderError'">
				<div class="d-flex text-center">Our apologies. There seems to be a problem completing your order.</div>
				<div class="d-flex text-center" *ngIf="paymentToken">While your credit card was authorized, it will not be finalized.</div>
			</ng-container>
		</div>
	</form>
</focus-sidebar>

<ng-template #sbCartFooterTemplate>
	<div class="p-3 w-100 d-flex align-items-center" *ngIf="continueMessage">
		<button
			type="button"
			class="btn btn-primary flex-grow-1 me-2"
			(click)="nextStep()"
			[ladda]="saving"
			[disabled]="
				(checkoutStep === 0 && check.items.length === 0) ||
				(f && f.form.invalid) ||
				!allowOrder ||
				!allowSubmit ||
				!deliveryAllowed ||
				(paymentMode === 'form' &&
					(!check.creditCard.cardNumber ||
						!check.creditCard.cardExpirationYear ||
						!check.creditCard.cardExpirationMonth ||
						!check.creditCard.cardCvv))
			"
			*ngIf="!savedCheck || check.newItems || checkoutStep === 'paymentComplete'"
		>
			{{ continueMessage }}
		</button>

		<button
			type="button"
			class="btn btn-primary flex-grow-1 me-2"
			(click)="orderPrePayment()"
			[ladda]="saving"
			[disabled]="!allowSubmit"
			*ngIf="checkoutStep === 'check' && paymentToken && !check.newItems"
		>
			Pay Check
		</button>

		<div *ngIf="checkoutStep === 'check' && !paymentToken && !check.newItems && check.total > 0">
			<span class="font-weight-bold">Check Staus: </span><span class="text-danger">NOT PAID</span>
		</div>

		<div class="ms-auto p-2 rounded border font-weight-bold fc-font-size-large clickable" (click)="opCheckTotals.toggle($event)">
			{{ check.total | currency }}
		</div>
	</div>
</ng-template>

<p-overlayPanel #opCheckTotals>
	<ng-template pTemplate>
		<div class="p-3 d-flex flex-column oo-check-totals" *ngIf="check" style="width: 250px">
			<div class="d-flex">
				<div>Subtotal</div>
				<div class="ms-auto">{{ check.subtotal | currency }}</div>
			</div>
			<div class="d-flex" *ngIf="check.orderTypeFee">
				<div>Order Fee</div>
				<div class="ms-auto">{{ check.orderTypeFee | currency }}</div>
			</div>
			<div class="d-flex" *ngIf="check.creditCardPassAlongFee">
				<div>{{ venue.mobilePayCCSurcharge }}</div>
				<div class="ms-auto">{{ check.creditCardPassAlongFee | currency }}</div>
			</div>
			<div class="d-flex">
				<div><span *ngIf="!check.verified">Estimated </span>Tax</div>
				<div class="ms-auto">{{ check.tax | currency }}</div>
			</div>
			<div class="d-flex" *ngIf="check.tip">
				<div>Tip</div>
				<div class="ms-auto">{{ check.tip | currency }}</div>
			</div>
			<div class="d-flex">
				<div><span *ngIf="!check.verified">Estimated </span>Total</div>
				<div class="ms-auto">{{ check.total | currency }}</div>
			</div>
			<div class="d-flex" *ngIf="check.remainingBalance">
				<div>Remaining Balance</div>
				<div class="ms-auto">{{ check.remainingBalance | currency }}</div>
			</div>
		</div>
	</ng-template>
</p-overlayPanel>

<p-dialog
	header="Terms of Service"
	[(visible)]="displayTos"
	[modal]="true"
	[style]="{ width: '50vw' }"
	[baseZIndex]="10000"
	[draggable]="false"
	[resizable]="false"
>
	<app-terms-and-conditions #tosModalTemplate (close)="displayTos = false"></app-terms-and-conditions>
</p-dialog>

<ng-template #promoModalTemplate let-modal>
	<div class="p-3 d-flex">
		<img
			class="m-auto img-fluid"
			[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/promo.png'"
			onError="this.src=''"
		/>
	</div>
</ng-template>

<p-confirmDialog [autoZIndex]="true" [baseZIndex]="99999" acceptButtonStyleClass="p-button-success" rejectButtonStyleClass="p-button-danger"></p-confirmDialog>

<app-order-type-time-change
	*ngIf="orderTimeTypeChange"
	[isMobile]="isMobile"
	[(orderDueDateTime)]="orderDueDateTime"
	[orderTypes]="venue.ooOrderTypes"
	[venueKey]="venueKey"
	[(futureOrderDate)]="futureOrderDate"
	[(futureOrderTime)]="futureOrderTime"
	[(orderTypeSelected)]="orderType"
	[(futureOrderMode)]="venue.futureOrderMode"
	(confirmationEmitter)="orderTimeTypeChange = $event; returnFromOrderTypeTimeSelect()"
>
</app-order-type-time-change>
<app-share-check *ngIf="shareCheckView && link" [(shareCheckView)]="shareCheckView" [(shareCheckUrl)]="link.shareUrl"></app-share-check>
<app-license-credential-prompt *ngIf="kioskMode && !kioskDeviceId" (licenseCredentialChange)="kioskStoreCredentials($event)"></app-license-credential-prompt>
